<script setup lang="ts">
import type { SeparatorProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { Separator } from 'reka-ui'

const props = defineProps<
  SeparatorProps & { class?: HTMLAttributes['class'], label?: string }
>()
const appConfig = useAppConfig()
const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Separator
    v-bind="delegatedProps"
    :class="
      cn(
        appConfig.ui.separator.slots.root,
        props.orientation === 'vertical' ? 'w-px h-full' : 'h-px w-full',
        props.class,
      )
    "
  >
    <span
      v-if="props.label"
      :class="cn(
        appConfig.ui.separator.slots.label,
        props.orientation === 'vertical' ? 'w-[1px] px-1 py-2' : 'h-[1px] py-1 px-2',
      )"
    >
      {{ props.label }}
    </span>
  </Separator>
</template>
